import React, { createContext, useContext } from "react";
import ContentMetadataStore from "./ContentMetadataStore";
import { ApolloLink } from "apollo-link";

const contentMetadataStore = new ContentMetadataStore(
  (typeof window !== "undefined" &&
    window.__CONTRIBUTION_MODE_DATA__?.metadata) ||
    []
);

const StorefrontContentMetadataContext = createContext({
  contentMetadataStore,
});

export const collectStorefrontContentMetadataLink = new ApolloLink(function (
  operation,
  forward
) {
  return forward(operation).map(function (result) {
    const resultMetadata = result.extensions?.contentMetadata || [];
    resultMetadata.forEach((metadata) => {
      contentMetadataStore.add(metadata);
    });
    return result;
  });
});

export const StorefrontContentMetadataProvider = ({ children }) => {
  return (
    <StorefrontContentMetadataContext.Provider value={{ contentMetadataStore }}>
      {children}
    </StorefrontContentMetadataContext.Provider>
  );
};

/**
 * @param {string} type
 * @param {string} id
 * @return {import("./ContentMetadataStore").ContentMetadata[]}
 */
export const useStorefrontContentMetadata = (type, id) => {
  const context = useContext(StorefrontContentMetadataContext);

  if (context === undefined) {
    throw new Error(
      "useStorefrontContentMetadata must be used within a StorefrontContentMetadataProvider"
    );
  }

  return context.contentMetadataStore.find(type, id);
};
